export default "__VITE_ASSET__7996279b__"